import { useCartContext } from '../../context/CartContext';
import { cartActionTypes, cartItemActionTypes } from '../../app/enums';
import RemoveIcon from '@material-ui/icons/Remove';
import AddIcon from '@material-ui/icons/Add';
import { Grid, Button, Divider, Avatar } from '@material-ui/core';
import { PrintCartLine } from './PrintCartLine';
import { Carts } from '../../api/api';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { CartItem } from '../../models/cart.interface';

const useStyles = makeStyles((theme: Theme) =>
  createStyles ({
    gridSpacer: {
      minHeight: '12px',
    },
    cartQtyButtons: {
      color: theme.palette.primary.contrastText,
      background: theme.palette.primary.main,
      height: '20px',
      width: '20px',
      border: "1px solid" ,
    },
  }),
);

export interface ICartLine {
  id: string,
  cartItem: CartItem,
  showDeleteDialog: (cartItem: CartItem) => void;
}

export const CartLine = ({
  id, cartItem, showDeleteDialog
}: ICartLine) => {
  const classes = useStyles();
  const { dispatch } = useCartContext();
  
  const handleAdd = () => {
    let qty = cartItem.quantity + 1
    updateCartItemQuantity(qty, cartItemActionTypes.ADD_ITEM_QUANTITY)
  };

  const handleSubtract = () => {
    if(cartItem.quantity === 1) {
      showDeleteDialog(cartItem)
    } else {
      let qty = cartItem.quantity - 1
      updateCartItemQuantity(qty, cartItemActionTypes.SUBTRACT_ITEM_QUANTITY)
    }
  };

  function updateCartItemQuantity(quantity: number, action: string){
    Carts.updateCartItem(cartItem.cartId, cartItem.cartItemId ?? '', quantity)
      .then((res) => {
        if(action === cartItemActionTypes.ADD_ITEM_QUANTITY) {
          dispatch({
            type: cartActionTypes.UPDATE_CART_ITEM, 
            item: cartItem, 
            action: cartItemActionTypes.ADD_ITEM_QUANTITY
          })
        }else if(action === cartItemActionTypes.SUBTRACT_ITEM_QUANTITY){
          dispatch({
            type: cartActionTypes.UPDATE_CART_ITEM, 
            item: cartItem, 
            action: cartItemActionTypes.SUBTRACT_ITEM_QUANTITY
          }) 
        }
    }).catch((error) => {
      console.log('Cart Line error', error)
    }) 
  }

  return (
    <>
      <Grid container spacing={0} justifyContent="space-between" alignItems="stretch">
        <Grid container className={classes.gridSpacer} />
        <PrintCartLine cartItem={cartItem} />
        <Grid container justifyContent="space-between" alignItems="flex-start">
          <Button color="primary" variant="outlined" size="small" onClick={() => showDeleteDialog(cartItem)}>
            Delete
          </Button>   
          <Grid item>
            <Grid container justifyContent="flex-end">    
              <Grid item> 
                <Avatar  className={classes.cartQtyButtons} variant="square" 
                  onClick={() => handleSubtract()}>
                  <RemoveIcon style={{  fontSize: 14 , color: 'primary' }} />
                </Avatar> 
              </Grid>
              <Grid item> 
                <Avatar  className={classes.cartQtyButtons} variant="square" 
                  onClick={() => handleAdd()}>
                  <AddIcon style={{  fontSize: 14 , color: 'primary' }} />
                </Avatar>
              </Grid>
            </Grid>
          </Grid>
        </Grid>   
      </Grid>
      <Grid container className={classes.gridSpacer} />
      <Divider />
    </>
  );
};

export default CartLine;
